<script>
import { API_URL, MEDIA_URL } from "@/core/api";
import moment from "moment";

export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      profile: JSON.parse(localStorage.getItem("profile")),
      mediaUrl: MEDIA_URL,
      file_url: null,
    };
  },
  mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    let cv_path = urlParams.get("path").replace(/-/g, "/");
    this.file_url = cv_path;
  },
  methods: {
    moment: function (item) {
      if (item) {
        return moment(String(item));
      }
    },
  },
};
</script>

<template>
  <!-- <embed
    :src="`https://drive.google.com/viewerng/viewer?embedded=true&url=${mediaUrl + file_url}`"
    width="100%"
    height="100%"
  /> -->
  <div>
    <iframe id="iframe1" :src="`http://docs.google.com/gview?url=${mediaUrl + file_url}&embedded=true`" style=" width: 100%; min-height: 80vh;"> </iframe>
  </div>
</template>